import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';
import { RolesActions, RolesActionTypes } from '@references/ngrx/actions/roles.actions';
import {RoleModel} from "@services/back-office/model/roleModel";

export const adapter: EntityAdapter<RoleModel> = createEntityAdapter<RoleModel>();

export interface State extends EntityState<RoleModel> {
  loading: boolean,
}

export const initialState: State = adapter.getInitialState({
  loading: false,
});

export function reducer(state = initialState, action: RolesActions): State {
  switch (action.type) {
    /** Load Roles */
    case RolesActionTypes.LoadRoles:
      return {...state, loading: !action.payload?.dontShowLoading};

    case RolesActionTypes.LoadRolesSuccess:
      return adapter.setAll(action.payload, {
        ...state,
        loading: false,
      });

    case RolesActionTypes.LoadRolesFailure:
      return {...state, loading: false};

    /** Edit Roles */
    case RolesActionTypes.EditRoles:
      return {...state};

    case RolesActionTypes.EditRolesSuccess:
      return adapter.updateOne({
        id: action.payload.id!,
        changes: action.payload,
      }, {...state});

    case RolesActionTypes.EditRolesFailure:
      return {...state};

    /** Set Initial State */
    case RolesActionTypes.SetInitialState:
      return {...initialState};

    default:
      return state;
  }
}

export const {
  selectIds: selectRolesIds,
  selectEntities: selectRolesEntities,
  selectAll: selectAllRoles,
  selectTotal: selectRolesTotal,
} = adapter.getSelectors();
